import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import { getEnv } from "@/helpers/env.helpers";
import type { Environment } from "@/types/common";

const enabledEnvs: Environment[] = ["prod"];

const environment = getEnv();
const SENTRY_DSN = String(import.meta.env.VITE_SENTRY_DSN ?? "");
const enabled = enabledEnvs.includes(environment);

// Note: we init sentry in all environments so we can catch any regressions with the way it spies on fetch/xhr.
// In local you can provide the SENTRY_DSN in .env.local
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    enabled,
    environment,

    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.captureConsoleIntegration({ levels: ["error", "log"] }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [],
    sendDefaultPii: false,
  });
} else {
  // eslint-disable-next-line no-console
  console.warn("Observability not initialised (SENTRY_DSN not defined)");
}
